<template>
  <div>
    <el-card class="">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('reportCustomComponentManage.queryCondition') }}</span>
      </div>
      <div class="filter-container">
        <el-form :inline="true" :model="reportCustomComponentManageInfo.conditions" class="flex justify-start">
          <el-form-item>
            <el-input v-model="reportCustomComponentManageInfo.conditions.componentId"
              :placeholder="$t('reportCustomComponentManage.inputComponentId')" clearable style="width:100%" />
          </el-form-item>
          <el-form-item>
            <el-input v-model="reportCustomComponentManageInfo.conditions.name"
              :placeholder="$t('reportCustomComponentManage.inputComponentName')" clearable style="width:100%" />
          </el-form-item>
          <el-form-item>
            <el-select v-model="reportCustomComponentManageInfo.conditions.componentType"
              :placeholder="$t('reportCustomComponentManage.selectComponentType')" clearable style="width:100%">
              <el-option v-for="item in componentTypeOptions" :key="item.value" :label="item.label"
                :value="item.value" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="_queryReportCustomComponentMethod">
              <i class="el-icon-search"></i>
              {{ $t('reportCustomComponentManage.query') }}
            </el-button>
            <el-button @click="_resetReportCustomComponentMethod">
              <i class="el-icon-refresh"></i>
              {{ $t('reportCustomComponentManage.reset') }}
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <el-card class="margin-top-sm">
      <div slot="header" class="clearfix flex justify-between">
        <span>{{ $t('reportCustomComponentManage.reportComponents') }}</span>
        <el-button type="primary" size="small" style="float:right;" @click="_openAddReportCustomComponentModal">
          <i class="el-icon-plus"></i>
          {{ $t('reportCustomComponentManage.add') }}
        </el-button>
      </div>
      <el-table :data="reportCustomComponentManageInfo.reportCustomComponents" border style="width:100%">
        <el-table-column prop="componentId" :label="$t('reportCustomComponentManage.componentId')" align="center" />
        <el-table-column prop="name" :label="$t('reportCustomComponentManage.componentName')" align="center" />
        <el-table-column prop="componentType" :label="$t('reportCustomComponentManage.componentType')" align="center">
          <template slot-scope="scope">
            {{ scope.row.componentType === '1001' ? $t('reportCustomComponentManage.table') :
              $t('reportCustomComponentManage.pieChart') }}
          </template>
        </el-table-column>
        <el-table-column prop="queryModel" :label="$t('reportCustomComponentManage.queryMethod')" align="center">
          <template slot-scope="scope">
            {{ scope.row.queryModel === '1' ? 'sql' : 'java' }}
          </template>
        </el-table-column>
        <el-table-column prop="remark" :label="$t('reportCustomComponentManage.description')" align="center" />
        <el-table-column :label="$t('reportCustomComponentManage.operation')" align="center" width="300">
          <template slot-scope="scope">
            <el-button v-if="scope.row.componentType === '1001'" size="mini"
              @click="_openComponentCondition(scope.row)">
              {{ $t('reportCustomComponentManage.setCondition') }}
            </el-button>
            <el-button v-if="scope.row.componentType === '1001'" size="mini" @click="_openComponentFooter(scope.row)">
              {{ $t('reportCustomComponentManage.footerStatistics') }}
            </el-button>
            <el-button size="mini" type="primary" @click="_openEditReportCustomComponentModel(scope.row)">
              {{ $t('reportCustomComponentManage.edit') }}
            </el-button>
            <el-button size="mini" type="danger" @click="_openDeleteReportCustomComponentModel(scope.row)">
              {{ $t('reportCustomComponentManage.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize"
        layout="total, prev, pager, next" :total="reportCustomComponentManageInfo.total"
        style="margin-top:20px;text-align:right;" />
    </el-card>

    <add-report-custom-component ref="addReportCustomComponent" />
    <edit-report-custom-component ref="editReportCustomComponent" />
    <delete-report-custom-component ref="deleteReportCustomComponent" />
  </div>
</template>

<script>
import { listReportCustomComponent } from '@/api/dev/reportCustomComponentApi'
import AddReportCustomComponent from '@/components/dev/addReportCustomComponent/addReportCustomComponent.vue'
import EditReportCustomComponent from '@/components/dev/editReportCustomComponent/editReportCustomComponent.vue'
import DeleteReportCustomComponent from '@/components/dev/deleteReportCustomComponent/deleteReportCustomComponent.vue'

export default {
  name: 'ReportCustomComponentManage',
  components: {
    AddReportCustomComponent,
    EditReportCustomComponent,
    DeleteReportCustomComponent
  },
  data() {
    return {
      reportCustomComponentManageInfo: {
        reportCustomComponents: [],
        total: 0,
        conditions: {
          componentId: '',
          name: '',
          componentType: ''
        }
      },
      componentTypeOptions: [
        { value: '1001', label: this.$t('reportCustomComponentManage.table') },
        { value: '2002', label: this.$t('reportCustomComponentManage.pieChart') },
        { value: '3003', label: this.$t('reportCustomComponentManage.input') },
        { value: '4004', label: this.$t('reportCustomComponentManage.select') },
        { value: '5005', label: this.$t('reportCustomComponentManage.date') }
      ],
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    this._listReportCustomComponents(this.currentPage, this.pageSize)
  },
  methods: {
    async _listReportCustomComponents(page, rows) {
      try {
        const params = {
          page,
          rows,
          ...this.reportCustomComponentManageInfo.conditions
        }
        const res = await listReportCustomComponent(params)
        this.reportCustomComponentManageInfo.reportCustomComponents = res.data
        this.reportCustomComponentManageInfo.total = res.total
      } catch (error) {
        console.error(error)
      }
    },
    _queryReportCustomComponentMethod() {
      this.currentPage = 1
      this._listReportCustomComponents(this.currentPage, this.pageSize)
    },
    _resetReportCustomComponentMethod() {
      this.reportCustomComponentManageInfo.conditions = {
        componentId: '',
        name: '',
        componentType: ''
      }
      this._queryReportCustomComponentMethod()
    },
    _openAddReportCustomComponentModal() {
      this.$refs.addReportCustomComponent.open()
    },
    _openEditReportCustomComponentModel(row) {
      this.$refs.editReportCustomComponent.open(row)
    },
    _openDeleteReportCustomComponentModel(row) {
      this.$refs.deleteReportCustomComponent.open(row)
    },
    _openComponentCondition(row) {
      this.$router.push({
        path: '/pages/dev/componentConditionManage',
        query: {
          componentId: row.componentId,
          componentName: row.name
        }
      })
    },
    _openComponentFooter(row) {
      this.$router.push({
        path: '/pages/dev/reportCustomComponentFooterManage',
        query: {
          componentId: row.componentId,
          componentName: row.name
        }
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listReportCustomComponents(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.filter-container {
  padding-bottom: 10px;
}

.box-card {
  margin-bottom: 20px;
}
</style>